module.exports = __webpack_public_path__ + "img/right.f40ac543.svg";